"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendNewVariableMessage = exports.sendVideoPlayedMessage = void 0;
const sendVideoPlayedMessage = () => {
    var _a;
    try {
        (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage({
            from: "typebot",
            videoPlayed: true,
        }, "*");
    }
    catch (err) {
        console.log("Error while trying to send video played message");
        console.error(err);
    }
};
exports.sendVideoPlayedMessage = sendVideoPlayedMessage;
const sendNewVariableMessage = (newVariableValue) => {
    var _a;
    try {
        (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage({
            from: "typebot",
            newVariableValue,
        }, "*");
    }
    catch (err) {
        console.log("Error while trying to send variable message");
        console.error(err);
    }
};
exports.sendNewVariableMessage = sendNewVariableMessage;
//# sourceMappingURL=messages.js.map